<template>
  <div>{{ computedData }}</div>
</template>
<script>
export default {
  name: "TableTotalPrice",
  props: {
    row: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedData: {
      get() {
        return new Intl.NumberFormat(localization.locale.code, {
          style: "currency",
          currency: this.currency,
        }).format(this.totalPrice);
      },
    },
    totalPrice: {
      get() {
        return this.row.price * this.row.quantity;
      },
      set(value) {
        this.row.total_price = value;
      },
    },
    currency() {
      return this.row.currency_code.code.toUpperCase();
    },
  },
};
</script>
